import { Routes } from '@angular/router';
import { APP_ROUTES } from '@core/constants/route.constant';
import { authGuard } from '@core/auth/guards/auth.guard';
import { nonAuthGuard } from '@core/auth/guards/non-auth.guard';
import { BoLayout } from '@layouts/bo-layout/bo-layout';
import { Dashboard } from '@features/dashboard/pages/dashboard/dashboard';
import { IncompleteEnterpriseList } from '@features/enterprises/pages/incomplete-enterprise-list/incomplete-enterprise-list';
import { ReportsList } from '@features/reports/pages/reports-list/reports-list';

export const routes: Routes = [
  {
    path: APP_ROUTES.AUTH.ROOT,
    canActivate: [nonAuthGuard],
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: APP_ROUTES.ADMIN.ROOT,
    canActivate: [authGuard],
    component: BoLayout,
    children: [
      {
        path: APP_ROUTES.ADMIN.DASHBOARD,
        component: Dashboard,
      },
      {
        path: APP_ROUTES.ADMIN.ENTERPRICES.ROOT,
        loadChildren: () =>
          import('@features/enterprises/enterprise.routes').then((m) => m.ENTERPRISE_ROUTES),
      },
      {
        path: APP_ROUTES.ADMIN.ENTERPRICES.INCOMPLETE,
        component: IncompleteEnterpriseList,
      },
      {
        path: APP_ROUTES.ADMIN.PLANS.ROOT,
        loadChildren: () => import('@features/plans/plan.routes').then((m) => m.PLAN_ROUTES),
      },
      {
        path: APP_ROUTES.ADMIN.FEATURES.ROOT,
        loadChildren: () =>
          import('@features/features/feature.routes').then((m) => m.FEATURE_ROUTES),
      },
      {
        path: APP_ROUTES.ADMIN.TEMPLATES.ROOT,
        loadChildren: () =>
          import('@features/templates/template.routes').then((m) => m.TEMPLATE_ROUTES),
      },
      {
        path: APP_ROUTES.ADMIN.LEAD_CAPTURE.ROOT,
        loadChildren: () =>
          import('@features/lead-capture/lead-capture.routes').then((m) => m.LEAD_CAPTURE_ROUTES),
      },
      {
        path: APP_ROUTES.ADMIN.REPORTS,
        component: ReportsList,
      },
      {
        path: '',
        redirectTo: APP_ROUTES.ADMIN.DASHBOARD,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: `${APP_ROUTES.AUTH.ROOT}/${APP_ROUTES.AUTH.LOGIN}`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: `${APP_ROUTES.AUTH.ROOT}/${APP_ROUTES.AUTH.LOGIN}`,
  },
];
